<template>
	<div class="sub-section">
		<Title
			title="Weitere Software"
			:completion-type="completionType"
			@edit="edit"
		/>
		<div :class="{'inline': isNone}">
			<SelectedItems
				:selected="selected"
				:characteristic-items="meta.skillSoftwareSpecial"
				none-info="Ich habe noch keine Erfahrung mit spezieller Software"
				class="no-left-padding"
				:styling="selectedItemsStyling"
				flat
			/>
		</div>
	</div>
</template>

<script>
import Title from "@/vue/common/profile-view/Title.vue";
import SelectedItems from "@/vue/characteristic/SelectedItems.vue";
import {mapActions} from "vuex";
import {isEmptyArray} from "@/helper/Array";
import {STYLING__LIST} from "@/vue/characteristic/SelectedItems"
import {sortLabel} from "@/helper/characteristic/Sort";
import _ from "lodash";

export default {
	components: {
		SelectedItems,
		Title
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
		completionType: {
			type: String,
			required: true,
		},
	},

	computed: {
		isNone ()
		{
			return isEmptyArray(this.value);
		},
		selectedItemsStyling ()
		{
			return STYLING__LIST;
		},
		selected ()
		{
			return this.value ? sortLabel(_.cloneDeep(this.value)) : undefined;
		}
	},

	methods: {
		...mapActions('application/skillSoftwareSpecial/fan', {
			openFan: 'show'
		}),
		edit ()
		{
			this.openFan({
				software: this.value,
				onClose: data =>
				{
					if (!data.confirmed || !data.software)
					{
						return;
					}

					this.$emit('change', {
						items: data.software,
						skipped: data.skipped
					});

					this.$emit('input', data.software);
				}
			});
		}
	},
}
</script>
